import { SafeLogErrorOptions } from '../log-error';
import { BaseError } from './BaseError';

export class TimeoutError extends BaseError {
    constructor(loggerFields: SafeLogErrorOptions) {
        super('Timed out', loggerFields);

        Object.setPrototypeOf(this, TimeoutError.prototype);
    }
}
